import { pick } from 'lodash';
import formatMoney from 'utils/formatters/Money';
import USER_TYPES from 'constants/UserTypes';
export function getRateSource(originalRateSource, original_rate, updated_rate) {
    if ((original_rate && updated_rate && original_rate === updated_rate) ||
        originalRateSource === 'overwritten_price_engine')
        return originalRateSource;
    if (originalRateSource === 'automated') {
        return 'overwritten_price_engine';
    }
    return 'manual';
}
export function getTotal(rate, qty, currency) {
    if (rate !== 0 && (!rate || !qty || !parseFloat(rate))) {
        return 'N/A';
    }
    const total = formatMoney(parseFloat(rate * qty), currency);
    if (String(total).indexOf('.') < 0) {
        return String(total) + '.00';
    }
    return String(total);
}
export const usingValidDecimals = (cost) => {
    if (!cost)
        return true;
    const charArray = cost.toString().split('');
    if (charArray.indexOf('.') > -1) {
        const index = charArray.indexOf('.');
        if (charArray[index + 3]) {
            return false;
        }
        return true;
    }
    return true;
};
export const colorLabelMap = {
    approved: 'green',
    accepted: 'blue',
    declined: 'red',
    'pending-admin': 'yellow',
    'pending-shipper': 'yellow',
};
export function getRequestFields(accessorial, isCarrier = true) {
    const rateField = isCarrier ? 'carrier_rate' : 'shipper_rate';
    const unitsField = isCarrier ? 'carrier_unit_qty' : 'shipper_unit_qty';
    const beginDateField = isCarrier
        ? 'begin_datetime'
        : 'shipper_begin_datetime';
    const endDateField = isCarrier ? 'end_datetime' : 'shipper_end_datetime';
    const locationField = isCarrier ? 'location' : 'shipper_location';
    const descriptionField = isCarrier ? 'description' : 'shipper_description';
    const notesField = isCarrier ? 'carrier_note' : 'shipper_note';
    const beginDate = accessorial[beginDateField];
    const endDate = accessorial[endDateField];
    const location = accessorial[locationField];
    const description = accessorial[descriptionField];
    const units = accessorial[unitsField];
    const rate = accessorial[rateField];
    const notes = accessorial[notesField];
    return {
        rateField,
        unitsField,
        beginDateField,
        endDateField,
        locationField,
        descriptionField,
        notesField,
        rate,
        units,
        beginDate,
        endDate,
        location,
        description,
        notes,
    };
}
export function buildUpdatePayload(formFields, accessorial, type) {
    let updated = pick(formFields, [
        'shipper_rate',
        'shipper_unit_qty',
        'admin_note',
        'carrier_note',
        'shipper_note',
        'carrier_rate',
        'carrier_unit_qty',
        'location',
        'begin_datetime',
        'end_datetime',
        'description',
        'shipper_location',
        'shipper_begin_datetime',
        'shipper_end_datetime',
        'shipper_description',
    ]);
    const original = pick(accessorial, [
        'shipper_rate',
        'shipper_unit_qty',
        'carrier_rate',
        'carrier_unit_qty',
        'rate_source',
        'receivable_rate_source',
        'payable_rate_source',
    ]);
    if (!original.shipper_rate && updated.shipper_rate) {
        original.shipper_rate = 0;
    }
    if (updated.shipper_note && updated.shipper_note.trim().length < 1) {
        delete updated.shipper_note;
    }
    if (updated.carrier_note && updated.carrier_note.trim().length < 1) {
        delete updated.carrier_note;
    }
    if (type === USER_TYPES.SHIPPER) {
        updated = Object.assign({ _id: formFields._id }, pick(updated, [
            'shipper_rate',
            'shipper_unit_qty',
            'shipper_note',
            'shipper_begin_datetime',
            'shipper_end_datetime',
            'shipper_location',
            'shipper_description',
        ]));
        if (updated.shipper_rate > 0 && !usingValidDecimals(updated.shipper_rate)) {
            updated.shipper_rate = parseFloat(updated.shipper_rate).toFixed(2);
        }
        if ((updated.shipper_rate > 0 && !usingValidDecimals(updated.shipper_rate)) ||
            updated.shipper_note) {
            updated.shipper_status = 'pending-shipper';
        }
        if (updated.carrier_rate) {
            updated.rate_source = getRateSource(original.rate_source, original.carrier_rate, updated.carrier_rate);
            updated.payable_rate_source = getRateSource(original.payable_rate_source, original.carrier_rate, updated.carrier_rate);
        }
        if (updated.shipper_rate) {
            updated.rate_source = getRateSource(original.rate_source, original.shipper_rate, updated.shipper_rate);
            updated.receivable_rate_source = getRateSource(original.receivable_rate_source, original.shipper_rate, updated.shipper_rate);
        }
    }
    else {
        updated = Object.assign({ _id: formFields._id }, pick(updated, [
            'carrier_rate',
            'carrier_unit_qty',
            'carrier_note',
            'begin_datetime',
            'end_datetime',
            'location',
            'description',
        ]));
        if (!updated.location)
            delete updated.location;
        if (!updated.begin_datetime)
            delete updated.begin_datetime;
        if (!updated.end_datetime)
            delete updated.end_datetime;
        if (!updated.shipper_location)
            delete updated.shipper_location;
        if (!updated.shipper_begin_datetime)
            delete updated.shipper_begin_datetime;
        if (!updated.shipper_end_datetime)
            delete updated.shipper_end_datetime;
        if (!updated.description)
            delete updated.description;
        if (!updated.shipper_description)
            delete updated.shipper_description;
        if (updated.carrier_rate > 0 && !usingValidDecimals(updated.carrier_rate)) {
            updated.carrier_rate = parseFloat(updated.carrier_rate).toFixed(2);
        }
        if (updated.carrier_rate || updated.shipper_rate) {
            updated.rate_source = getRateSource(original.rate_source);
        }
        if (updated.carrier_rate) {
            updated.rate_source = getRateSource(original.rate_source, original.carrier_rate, updated.carrier_rate);
            updated.payable_rate_source = getRateSource(original.payable_rate_source, original.carrier_rate, updated.carrier_rate);
        }
        if (updated.shipper_rate) {
            updated.rate_source = getRateSource(original.rate_source, original.shipper_rate, updated.shipper_rate);
            updated.receivable_rate_source = getRateSource(original.receivable_rate_source, original.shipper_rate, updated.shipper_rate);
        }
        if ((updated.carrier_rate > 0 && !usingValidDecimals(updated.carrier_rate)) ||
            updated.carrier_note) {
            updated.carrier_status = 'pending-admin';
        }
    }
    if (updated &&
        typeof updated === 'object' &&
        Object.keys(updated).length > 1) {
        return updated;
    }
    return null;
}
export function buildResolutionPayload(accessorial, options) {
    const { action, type, declineNote, declineReasonCode, isVendorPaid, isBulk, shipmentId, } = options;
    if (action === 'decline' && (!declineNote || declineNote.trim() === '')) {
        return { payload: null, validationError: 'PROVIDE_DECLINE_NOTE' };
    }
    const payload = { resolution_type: action };
    if (action === 'decline') {
        // Build minimal accessorial object per resolve-status schema
        const acc = {
            _id: accessorial._id,
            shipment: { _id: shipmentId },
            meta: {},
        };
        if (isBulk) {
            payload.sendEmail = true;
            if (declineReasonCode) {
                acc.carrierDeclineReasonCode = declineReasonCode;
            }
            acc.meta.shipper_note = declineNote;
            acc.meta.carrier_note = declineNote;
            if (accessorial.payer_type === USER_TYPES.CONSIGNEE) {
                acc.declineConsigneePayer = true;
            }
            else if (accessorial.payee_type === USER_TYPES.VENDOR) {
                acc.declineVendor = !isVendorPaid;
            }
            else {
                acc.declineCarrier = true;
            }
            if (accessorial.payee_type === USER_TYPES.PARTNER) {
                acc.declinePartnerPayee = true;
            }
            else {
                acc.declineShipper = true;
            }
        }
        else {
            if (type === USER_TYPES.CARRIER) {
                payload.sendEmail = true;
                acc.meta.carrier_note = declineNote;
                switch (accessorial.payee_type) {
                    case USER_TYPES.CARRIER:
                        acc.declineCarrier = true;
                        acc.carrierDeclineReasonCode = declineReasonCode;
                        break;
                    case USER_TYPES.VENDOR:
                        acc.declineVendor = !isVendorPaid;
                        break;
                    case USER_TYPES.PARTNER:
                        acc.declinePartnerPayee = true;
                        break;
                    default:
                        acc.declineCarrier = true;
                        break;
                }
            }
            if (type === USER_TYPES.SHIPPER) {
                if (accessorial.payer_type === USER_TYPES.CONSIGNEE) {
                    acc.declineConsigneePayer = true;
                }
                else {
                    acc.declineShipper = true;
                }
                acc.meta.shipper_note = declineNote;
            }
        }
        payload.accessorials = [acc];
        return { payload, validationError: null };
    }
    // Approve path
    const acc = Object.assign(Object.assign({}, accessorial), { meta: Object.assign({}, (accessorial.meta || {})) });
    if (isBulk) {
        payload.sendEmail = true;
        if (acc.payee_type === USER_TYPES.VENDOR) {
            acc.approveVendor = !isVendorPaid;
        }
        else if (acc.payee_type === USER_TYPES.PARTNER) {
            acc.approvePartnerPayee = true;
        }
        else {
            acc.approveCarrier = true;
        }
        if (acc.payer_type === USER_TYPES.CONSIGNEE) {
            acc.approveConsigneePayer = true;
        }
        else {
            acc.approveShipper = true;
        }
    }
    else {
        if (type === USER_TYPES.CARRIER) {
            payload.sendEmail = true;
            switch (acc.payee_type) {
                case USER_TYPES.CARRIER:
                    acc.approveCarrier = true;
                    break;
                case USER_TYPES.VENDOR:
                    acc.approveVendor = !isVendorPaid;
                    break;
                case USER_TYPES.PARTNER:
                    acc.approvePartnerPayee = true;
                    break;
                default:
                    acc.approveCarrier = true;
                    break;
            }
        }
        if (type === USER_TYPES.SHIPPER) {
            if (acc.payer_type === USER_TYPES.CONSIGNEE) {
                acc.approveConsigneePayer = true;
            }
            else {
                acc.approveShipper = true;
            }
        }
    }
    payload.accessorials = [acc];
    return { payload, validationError: null };
}
